import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";
import SEOHead from "@/lib/seo/SEOHead";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking");
  const [planId, setPlanId] = useState("");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
        setPlanId(data.plan_id);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refreshUser();
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch {}
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-6">
      <SEOHead path="/billing/success" />
      <div className="max-w-lg w-full bento p-10 text-center" data-testid="billing-success">
        {status === "checking" && (<>
          <span className="spinner text-[#002FA7] mx-auto mb-6"></span>
          <h1 className="font-display text-2xl font-bold mb-2">Confirming your payment…</h1>
          <p className="text-zinc-600">This usually takes a few seconds.</p>
        </>)}
        {status === "paid" && (<>
          <CheckCircle size={48} className="mx-auto text-[#22C55E] mb-4" weight="fill" />
          <h1 className="font-display text-3xl font-black tracking-tighter mb-2">You're in.</h1>
          <p className="text-zinc-600 mb-6">{planId} is now active. Time to dominate the Local Pack.</p>
          <Link to="/app" className="btn-primary justify-center w-full">Go to dashboard <ArrowRight size={14} weight="bold" /></Link>
        </>)}
        {(status === "expired" || status === "error" || status === "timeout") && (<>
          <h1 className="font-display text-2xl font-bold mb-2">Something didn't go through.</h1>
          <p className="text-zinc-600 mb-6">Try again, or contact support.</p>
          <Link to="/pricing" className="btn-secondary justify-center w-full">Back to pricing</Link>
        </>)}
      </div>
    </div>
  );
}
